import config from "../config";
import getAccessToken from "./auth";

export const fetchCodedCaseId = async (teamsMeetingId: string): Promise<string> => {
  const accessToken = await getAccessToken();
  const response = await fetch(`${config.apiEndpoint}/api/case/meeting/${teamsMeetingId}/coded-id`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      "x-functions-key": config.functionKey
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch coded case ID: ${response.statusText}`);
  }

  const responseData = await response.json();
  return responseData.codedCaseId;
};
